import { formatCPFOrCNPJ } from 'src/app/helpers/utils/cpf-cnpj.util';

export {
  CarbonCreditTypeBadge,
  CarbonCreditTypeBadgeTone,
  resolveCarbonCreditTypeBadge,
} from './carbon-credit-type-badge.utils';

export function formatComitenteDocument(value?: string | null): string {
  return value ? formatCPFOrCNPJ(value) : '-';
}

export function isExternalUrl(value?: string | null): boolean {
  if (!value) {
    return false;
  }

  return /^https?:\/\//i.test(value.trim());
}

export function displayValue(value?: string | number | null): string {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  return String(value);
}
